<template>
<div v-if="auth.token && auth.login">
  <div class="bg-white py-3 px-2 rounded border mb-4">
      <label>موجودی کیف پول :</label>
      <span class="px-2 text-success prfont-weight creditVal">{{ convertToPersian(numberFormat(String(auth.profile.sum_wallet))) }}</span>
      <span>تومان</span>
  </div>
  <div>
    <div class="person-info mb-3">
      <div class="bg-white rounded border show-div-id">
        <div class="w-100">
          <div class="d-flex align-items-center p-2 prbg-gray rounded">
            <label>نام : *</label>
            <span v-if="editVal == false" class="mr-auto" id="name">{{ auth.profile.name }}</span>
            <input v-else type="text" class="form-control color-text p-margin" v-model="auth.profile.name">
          </div>
          <div class="d-flex align-items-center p-2 rounded">
            <label>نام خانوادگی : *</label>
            <span v-if="editVal == false" class="mr-auto" id="family">{{ auth.profile.family }}</span>
            <input v-else type="text" class="form-control color-text p-margin" v-model="auth.profile.family">
          </div>
          <div class="d-flex align-items-center p-2 prbg-gray rounded">
            <label>ایمیل : </label>
            <span v-if="editVal == false" class="mr-auto" id="email">{{ auth.profile.email }}</span>
            <input v-else type="text" class="form-control color-text p-margin dir-ltr" v-model="auth.profile.email">
          </div>
          <div class="d-flex align-items-center p-2 rounded">
            <label>شماره همراه : *</label>
            <span v-if="editVal == false" class="mr-auto" id="mobile">{{ auth.profile.mobile }}</span>
            <input v-else type="text" class="form-control color-text p-margin" disabled v-model="auth.profile.mobile">
          </div>
          <div class="d-flex align-items-center p-2 rounded prbg-gray" style="justify-content:space-between;">
            <label>جنسیت : </label>
            <div v-if="editVal == false">
              <span class="mr-auto" id="gender" v-if="auth.profile.gender == 1">مرد</span>
              <span class="mr-auto" id="gender" v-if="auth.profile.gender == 2">زن</span>
              <span class="mr-auto" id="gender" v-if="auth.profile.gender > 2">انتخاب نشده</span>
            </div>
            <div v-else>
              <select class="form-control w-100" style="border-radius: 4px;width: 100%;"
                id="gender_edit" v-model="auth.profile.gender">
                <option value="3" disabled>جنسیت</option>
                <option value="1" >مرد</option>
                <option value="2" >زن</option>
              </select>
            </div>
          </div>
          <div class="d-flex align-items-center p-2  rounded">
            <label>کد ملی : </label>
            <span v-if="editVal == false" class="mr-auto" id="nationalCode">{{ auth.profile.nid }}</span>
            <input v-else type="text" class="form-control color-text p-margin dir-ltr" v-model="auth.profile.nid">
          </div>
          <div class="d-flex align-items-center p-2 rounded prbg-gray" style="justify-content: space-between;">
            <label>تاریخ تولد : *</label>
            <span v-if="editVal == false && auth.profile.born == '1401/01/01'" class="mr-auto" >انتخاب نشده</span>
            <button @click="getBornTemp" v-if="editVal && auth.profile.born == '1401/01/01'" class="btn btn-transparent bore-0"><i class="bi bi-edit"></i> </button>
            
            <span v-if="editVal == false && auth.profile.born != '1401/01/01'" class="mr-auto" id="date_of_birth">{{auth.profile.born }}</span>
            <span v-if="editVal && auth.profile.born != '1401/01/01'" class="mr-auto" >{{auth.profile.born }}</span>
          </div>
          <div class="d-flex align-items-center p-2 rounded">
            <label>آدرس :*</label>
            <span v-if="editVal == false" class="mr-auto" id="userAddress">{{ auth.profile.location }}</span>
              <input type="text" v-else class="form-control color-text p-margin bg-light" disabled v-model="auth.profile.location">
          </div>
              <small class="text-danger pr-2" v-if="editVal"> آدرس فقط در سبد خرید قابل تغییر است.</small>
          <div class="d-flex align-items-center p-2 rounded prbg-gray">
            <label>آدرس دوم :*</label>
            <span v-if="editVal == false" class="mr-auto" id="userAddress2">{{ auth.profile.location2 }}</span>
              <input type="text" v-else class="form-control color-text p-margin  bg-light" disabled v-model="auth.profile.location2">
          </div>
          <div class="d-flex align-items-center p-2 rounded">
            <label>آدرس سوم :*</label>
            <span v-if="editVal == false" class="mr-auto" id="userAddress3">{{ auth.profile.location3 }}</span>
              <input type="text" v-else class="form-control color-text p-margin  bg-light" disabled v-model="auth.profile.location3">
          </div>
          <div class="d-flex align-items-center p-2 prbg-gray rounded">
            <label>شماره شبا : </label>
            <span v-if="editVal == false" class="mr-auto" id="sheba_number">{{ auth.profile.sheba }}</span>
            <input v-else type="text" class="form-control color-text p-margin dir-ltr" v-model="auth.profile.sheba">
          </div>
          <div class="d-flex align-items-center p-2 prbg-gray rounded" v-if="editVal">
            <label>رمز عبور : </label>
            <input type="text" class="form-control color-text p-margin dir-ltr" v-model="auth.profile.password">
          </div>
          <div class="ow mt-2">
              <button class="btn btn-info py-1 w-100 text-light" v-if="!editValBTN" @click="toggleEdit">ویرایش پروفایل</button>
              <button class="btn btn-success py-1 w-100" v-else @click="setInformation">ذخیره تغییرات</button>
              <button class="btn-rezerv mr-auto my-1 w-100 btn-red" @click="exitAccount" style="border:none;color:#ff5155 !important;border:none !important">خروج</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="text-danger" v-else>
شمامجوز دسترسی به این صفحه را ندارید
</div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { alertBox } from "@/composables/silverBox";
import { useRouter } from "vue-router";
import { numberFormat,convertToPersian } from "@/composables/digits";
import { useAuth } from '@/store/auth'
let auth = useAuth()

let editVal = ref(false);
let editValBTN = ref(false);
let router = useRouter();
async function setInformation() {
  
  if(auth.profile.password.length < 4){
    alertBox("رمز عبور نباید کمتر از 4 کاراکتر باشد",'error')
  }else if(!auth.profile.name.trim()){
    alertBox("نام نمیتواند خالی باشد",'error')
  }else if(!auth.profile.family.trim()){
    alertBox("نام خانوادگی نمیتواند خالی باشد",'error')
  }else {
    if(document.getElementById('dataPickerContainer')){
      document.getElementById('dataPickerContainer').classList.remove('d-none')
    }
    const formData = new FormData();
    formData.append('name', auth.profile.name);
    formData.append('family', auth.profile.family);
    formData.append('token', auth.token);
    formData.append('nid', auth.profile.nid);
    formData.append('sheba', auth.profile.sheba);
    formData.append('gender', auth.profile.gender);
    formData.append('email', auth.profile.email);
    formData.append('password', auth.profile.password);
    let response = await fetch('https://radap.ir/Backend/api/account/profile/set.php', {
      method: 'POST',
      body: formData
    });
      let data = await response.text()
      if(data == 'anon'){
        alertBox('شما مجوز دسترسی ندارید','error')
      }else{
        alertBox("اطلاعات شما با موفقیت ویرایش شد وپس از تایید نمایش داده خواهد شد",'success')
        auth.getAuth()
        toggleEdit()
        window.scrollTo(0,0)
      }
  }

}
function exitAccount() {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("token");
  localStorage.removeItem("basket");
  localStorage.removeItem("bsId");
  router.push('/')
  location.reload()
}
function getBornTemp() {
  document.getElementById('bornModalBTN').click()
}
function toggleEdit(){
  editVal.value = !editVal.value;
  editValBTN.value = !editValBTN.value;
}
</script>
